import _ from 'lodash';
import $ from 'jquery';
import Widget from 'gears/ui/widget/component';

// creates an array of numbers (of length "count") that add up to the "sum" argument
// the numbers are randomized to deviate from the median (based on the deviation argument)
var randomIntervals = function(count, sum, deviation, set) {
  if (deviation == null) { deviation = .5; }
  if (set == null) { set = []; }
  if (count > 1) {
    let median = sum / count;
    let intervalMin = median * (1 - deviation);
    let intervalMax = median * (1 + deviation);
    let interval = _.random(intervalMin, intervalMax);
    return randomIntervals(count - 1, sum - interval, deviation, set.concat(interval));
  } else {
    return set.concat(sum);
  }
};

class Progress extends Widget {

  simulate(value, duration, callback) {
    let increment;
    let totalDistance = value - this.options.value;
    let intervalCount = Math.round(duration/300); // 300 is the number of time between updates
    let timeIntervals = randomIntervals(intervalCount, duration);
    let distanceIntervals = randomIntervals(intervalCount, totalDistance);
    (increment = () => {
      let time = timeIntervals.pop();
      this.set({value: this.options.value += distanceIntervals.pop()});
      this.$bar.css("width", `${this.options.value}%`);
      if (timeIntervals.length) {
        return this.timeout = setTimeout(increment, time);
      } else {
        this.set(this.options.value = value);
        return __guardFunc__(callback, f => f());
      }
    }
    )();
    return this;
  }

  set() {
    super.set(...arguments);
    // call the onComplete callback when the value reaches 100
    if (this.options.value >= 100) { __guard__(this.options.onComplete, x => x.call(this.$el[0])); }
    return this;
  }

  destroy() {
    this.$el.remove();
    return this;
  }

  _initialize() {
    super._initialize(...arguments);
    if (this.$target) {
      this.$el = this.$target;
      return this._render();
    } else {
      this._render();
      return this.$target = this.$el.data(this._getNamespace(), this);
    }
  }

  _update() {
    return this._render();
  }

  _render(options) {
    // super(_.defaults(options, {attributes:{class: "progress"}}))
    if (!this.$el) {
      this.$el = $(`<div class=\"${Progress.className}\" />`);
    }

    // stop a currenly running simulation
    clearTimeout(this.timeout);

    if (this.$el.children().length) {
      this.$bar = this.$el.children().first();
    } else {
      this.$bar = $(`<div class=\"${Progress.className}__value\" />`).appendTo(this.$el);
    }
    this.$bar.css("width", `${this.options.value}%`);

    if (this.changedOptions.type) {
      this.$el.addClass(`${Progress.className}--${this.options.type}`);
      if (this.previousOptions.type) { this.$el.removeClass(`${Progress.className}--${this.previousOptions.type}`); }
    }

    // update the value if it"s changed
    if (this.options.value !== this.previousOptions.value) { return this.$bar.css("width", `${this.options.value}%`); }
  }
}


Progress.defaults = {
  value: 0
  // type: (optional)
  // onComplete: (optional)
};

Progress.className = "progress";

Progress.namespace = "gears:progress";

export default Progress;

function __guardFunc__(func, transform) {
  return typeof func === 'function' ? transform(func) : undefined;
}
function __guard__(value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined;
}
